import API from '../api/Http'
import * as EndPoints from '../api/EndPoints'
import { message } from 'antd'
import { RESPONSE_MESSAGE } from '../utils/constants'

const FETCH_BRAND_COVER_REQUEST = 'BrandCover/FETCH_BRAND_COVER_REQUEST'
const FETCH_BRAND_COVER_SUCCESS = 'BrandCover/FETCH_BRAND_COVER_SUCCESS'
const FETCH_BRAND_COVER_FAILURE = 'BrandCover/FETCH_BRAND_COVER_FAILURE'

const FETCH_BRAND_COVER_BY_ID_REQUEST =
  'BrandCover/FETCH_BRAND_COVER_BY_ID_REQUEST'
const FETCH_BRAND_COVER_BY_ID_SUCCESS =
  'BrandCover/FETCH_BRAND_COVER_BY_ID_SUCCESS'
const FETCH_BRAND_COVER_BY_ID_FAILURE =
  'BrandCover/FETCH_BRAND_COVER_BY_ID_FAILURE'

const CREATE_BRAND_COVER_REQUEST = 'BrandCover/CREATE_BRAND_COVER_REQUEST'
const CREATE_BRAND_COVER_SUCCESS = 'BrandCover/CREATE_BRAND_COVER_SUCCESS'
const CREATE_BRAND_COVER_FAILURE = 'BrandCover/CREATE_BRAND_COVER_FAILURE'

const UPDATE_BRAND_COVER_REQUEST = 'BrandCover/UPDATE_BRAND_COVER_REQUEST'
const UPDATE_BRAND_COVER_SUCCESS = 'BrandCover/UPDATE_BRAND_COVER_SUCCESS'
const UPDATE_BRAND_COVER_FAILURE = 'BrandCover/UPDATE_BRAND_COVER_FAILURE'

const DELETE_BRAND_COVER_REQUEST = 'BrandCover/DELETE_BRAND_COVER_REQUEST'
const DELETE_BRAND_COVER_SUCCESS = 'BrandCover/DELETE_BRAND_COVER_SUCCESS'
const DELETE_BRAND_COVER_FAILURE = 'BrandCover/DELETE_BRAND_COVER_FAILURE'

// Initialize State
const initialState = {
  isLoading: true,
  error: {},
  brandCoverList: [],
  brandCoverObj: {}
}

// Default Reducer
const brandCover = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_BRAND_COVER_REQUEST:
      return {
        ...state,
        isLoading: true
      }
    case FETCH_BRAND_COVER_SUCCESS:
      return {
        ...state,
        isLoading: false,
        brandCoverList: action.payload
      }
    case FETCH_BRAND_COVER_FAILURE:
      return {
        ...state,
        error: action.error,
        isLoading: false
      }
    case FETCH_BRAND_COVER_BY_ID_REQUEST:
      return {
        ...state,
        isLoading: true
      }
    case FETCH_BRAND_COVER_BY_ID_SUCCESS:
      return {
        ...state,
        isLoading: false,
        brandCoverObj: action.payload
      }
    case FETCH_BRAND_COVER_BY_ID_FAILURE:
      return {
        ...state,
        error: action.error,
        isLoading: false
      }
    case CREATE_BRAND_COVER_REQUEST:
      return {
        ...state,
        isLoading: true
      }
    case CREATE_BRAND_COVER_SUCCESS:
      return {
        ...state,
        isLoading: false
      }
    case CREATE_BRAND_COVER_FAILURE:
      return {
        ...state,
        error: action.error,
        isLoading: false
      }
    case UPDATE_BRAND_COVER_REQUEST:
      return {
        ...state,
        isLoading: true
      }
    case UPDATE_BRAND_COVER_SUCCESS:
      return {
        ...state,
        isLoading: false
      }
    case UPDATE_BRAND_COVER_FAILURE:
      return {
        ...state,
        error: action.error,
        isLoading: false
      }
    case DELETE_BRAND_COVER_REQUEST:
      return {
        ...state,
        isLoading: true
      }
    case DELETE_BRAND_COVER_SUCCESS:
      return {
        ...state,
        isLoading: false
      }
    case DELETE_BRAND_COVER_FAILURE:
      return {
        ...state,
        error: action.error,
        isLoading: false
      }
    default:
      return state
  }
}

export default brandCover

// Action Creators
export const fetchBrandCoverList = (brandId) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: FETCH_BRAND_COVER_REQUEST
      })

      const response = await API.get(
        EndPoints.BRAND_COVER + `/brand/${brandId}`
      )
      dispatch({
        type: FETCH_BRAND_COVER_SUCCESS,
        payload: response.data
      })
    } catch (err) {
      dispatch({
        type: FETCH_BRAND_COVER_FAILURE
      })
    }
  }
}

export const createBrandCover = (data) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: CREATE_BRAND_COVER_REQUEST
      })

      await API.post(EndPoints.BRAND_COVER, data)
      dispatch({
        type: CREATE_BRAND_COVER_SUCCESS
      })
      message.success(RESPONSE_MESSAGE.SUCCESS)
    } catch (err) {
      message.error(RESPONSE_MESSAGE.FAIL)
      dispatch({
        type: CREATE_BRAND_COVER_FAILURE
      })
    }
  }
}

export const createBrandCoverList = (data) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: CREATE_BRAND_COVER_REQUEST
      })

      await API.post(EndPoints.BRAND_COVER_LIST, data)
      dispatch({
        type: CREATE_BRAND_COVER_SUCCESS
      })
      message.success(RESPONSE_MESSAGE.SUCCESS)
    } catch (err) {
      message.error(RESPONSE_MESSAGE.FAIL)
      dispatch({
        type: CREATE_BRAND_COVER_FAILURE
      })
    }
  }
}

export const updateBrandCover = (data) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: UPDATE_BRAND_COVER_REQUEST
      })

      await API.put(EndPoints.BRAND_COVER, data)
      dispatch({
        type: UPDATE_BRAND_COVER_SUCCESS
      })
      message.success(RESPONSE_MESSAGE.SUCCESS)
    } catch (err) {
      message.error(RESPONSE_MESSAGE.FAIL)
      dispatch({
        type: UPDATE_BRAND_COVER_FAILURE
      })
    }
  }
}

export const deleteBrandCover = (id) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: DELETE_BRAND_COVER_REQUEST
      })

      await API.delete(EndPoints.BRAND_COVER + `/${id}`)
      dispatch({
        type: DELETE_BRAND_COVER_SUCCESS
      })
      message.success(RESPONSE_MESSAGE.SUCCESS)
    } catch (err) {
      message.error(RESPONSE_MESSAGE.FAIL)
      dispatch({
        type: DELETE_BRAND_COVER_FAILURE
      })
    }
  }
}
